// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2951":"css/app.6715","8877":"css/admin-app.6715"}[chunkId] + ".css";
};